document.addEventListener("DOMContentLoaded", function () {
  function replayAnimation(el) {
    if (!el) return;
    el.style.animation = "none";
    el.offsetHeight; // force reflow
    el.style.animation = "";
  }

  const menuDetails = document.querySelectorAll(".header__inline-menu details");

  menuDetails.forEach(detail => {
    const submenu = detail.querySelector(".header__submenu");

    detail.addEventListener("click", (e) => {
      // Make sure only <summary> triggers
      if (e.target.tagName.toLowerCase() !== "summary") return;

      e.preventDefault();

      const isOpen = detail.hasAttribute("open");

      // Close all
      menuDetails.forEach(d => d.removeAttribute("open"));

      // Toggle clicked one
      if (!isOpen) {
        detail.setAttribute("open", "true");
        replayAnimation(submenu);
      }
    });
  });

  // -------------------------------
  // CLOSE WHEN CLICKING OUTSIDE
  // -------------------------------
  document.addEventListener("click", (e) => {
    // if click is inside a menu, ignore
    if (e.target.closest(".header__inline-menu details")) return;

    // close all menus
    menuDetails.forEach(d => d.removeAttribute("open"));
  });
});
